import $ from 'jquery';
import * as Utils from 'lib/utils';
import lightGallery from 'lightgallery';
import lgThumbnails from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

const W = window;

lgZoom.prototype.setActualSize = function () {
  this.zoomIn();
};

$.fn.gallery = function (items, index) {
  const $obj = this;
  let gallery = $obj.data('gallery');

  if (Utils.isNumber(items)) {
    index = items;
    items = null;
  }

  if (!gallery && Utils.isArray(items)) {
    gallery = lightGallery(this[0], {
      licenseKey: 'BD0BAF9D-3D0C-41C3-8E34-B1E1026FF791',
      plugins: [lgThumbnails, lgZoom, lgVideo],
      zoom: true,
      scale: 1,
      infiniteZoom: true,
      showZoomInOutIcons: true,
      actualSize: false,
      thumbnail: true,
      animateThumb: true,
      video: true,
      dynamic: true,
      dynamicEl: items,
      download: false,
      mousewheel: true,
    });

    $obj.data('gallery', gallery);
  }

  if (gallery && index >= 0) {
    gallery.openGallery(index);
  }

  return this;
};
